import { CUSTOMERLIST , CUSTOMERSTATUS , CUSTOMERDETAILS } from "../../Constants/CustomerConstants";
import { createGetDataReducer } from "./CommonReducer";


export const CustomerGetReducer = createGetDataReducer( CUSTOMERLIST );
export const CustomerStatusGetReducer = createGetDataReducer( CUSTOMERSTATUS );
export const CustomerDetailsGetReducer = createGetDataReducer( CUSTOMERDETAILS );


